import { backendServices, getQuestionnaireItemFieldKey, QuestionnaireFormData } from 'common';
import { BuildSimDocumentArgs, buildSimDocumentViewModel, SimSubmissionContext } from '../../_shared/simDocumentVM';
import { QuestionnaireSimEntry } from './questionnaireSimSchema';

function normalizeQuestionnaireAnswerValue(value: string | boolean): string {
    if (typeof value === 'boolean') {
        return value ? 'true' : 'false';
    }

    return value;
}

function questionnaireAnswersToSimDocumentFields(
    answers: QuestionnaireSimEntry['answers'],
    questionnaire: QuestionnaireFormData
): Record<string, string> {
    const fields = Object.fromEntries(
        Object.entries(answers).map(([fieldKey, value]) => [fieldKey, normalizeQuestionnaireAnswerValue(value)])
    );

    questionnaire.items.forEach((item, itemIndex) => {
        if (item.type === 'Label') {
            fields[getQuestionnaireItemFieldKey(itemIndex)] = item.name;
        }
    });

    return fields;
}

/**
 * Converts a completed questionnaire entry into a SIM DocumentViewModel for POST /Document/Draft.
 */
export function convertQuestionnaireEntryToVM(
    entry: QuestionnaireSimEntry,
    questionnaire: QuestionnaireFormData,
    skeleton: BuildSimDocumentArgs['skeleton'],
    context: SimSubmissionContext,
    simDocumentTypeId: number | null,
    simRequestId?: number
): backendServices.ViewModels.DocumentViewModel {
    return buildSimDocumentViewModel({
        skeleton,
        context,
        documentClass: entry.businessDocSubTypeId,
        description: questionnaire.name,
        documentType: questionnaire.name,
        headerInfo: {},
        simDocumentFields: questionnaireAnswersToSimDocumentFields(entry.answers, questionnaire),
        simDocumentTypeId,
        simRequestId,
    });
}
